var MapLocation = /** @class */ (function () {
    function MapLocation() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length == 1) {
            var location_1 = args[0];
            this.id = location_1.id;
            this.lat = location_1.lat;
            this.lng = location_1.lng;
            this.title = location_1.title.trim();
            this.categories = location_1.categories;
            this.teaser = location_1.teaser;
            this.links = location_1.links;
        }
        else if (args.length == 5 || args.length == 7) {
            this.id = args[0];
            this.lat = args[1];
            this.lng = args[2];
            this.title = args[3].trim();
            this.categories = args[4];
            this.teaser = args.length >= 6 ? args[5] : null;
            this.links = args.length >= 7 ? args[6] : [];
        }
        else {
            throw new Error("Invalid Constructor call");
        }
    }
    MapLocation.prototype.getPrimaryCategorySlug = function () {
        return (this.categories.length > 0 ? this.categories[0].slug : '').trim().toLowerCase();
    };
    MapLocation.prototype.calcDistanceMeters = function (other) {
        // src: https://www.geeksforgeeks.org/program-distance-two-points-earth/
        var thisLngRad = this.lng * Math.PI / 180;
        var thisLatRad = this.lat * Math.PI / 180;
        var otherLngRad = other.lng * Math.PI / 180;
        var otherLatRad = other.lat * Math.PI / 180;
        var lngDiff = otherLngRad - thisLngRad;
        var latDiff = otherLatRad - thisLatRad;
        var a = Math.pow(Math.sin(latDiff / 2), 2)
            + Math.cos(this.lat) * Math.cos(other.lat)
                * Math.pow(Math.sin(lngDiff / 2), 2);
        var c = 2 * Math.asin(Math.sqrt(a));
        // Radius of earth in kilometers. Use 3956 for miles
        var r = 6371;
        return r * c * 1000;
    };
    //-------------------------------------------
    MapLocation.prototype.toLatLng = function () {
        return [this.lat, this.lng];
    };
    MapLocation.prototype.toLngLat = function () {
        return [this.lng, this.lat];
    };
    return MapLocation;
}());
export default MapLocation;
